import React from 'react';
import { Stars } from './QuickTestimonials';
import { DETAILED_TESTIMONIALS } from '../data/testimonials';
export function Testimonials() {
  return <section aria-labelledby="testimonials-title" className="w-full bg-night px-4 py-8" data-id="element-229" data-mp="3kr5tk627v5kr">
      <div className="mx-auto max-w-6xl" data-id="element-230" data-mp="3fy2zzxxfvw4k">
        <div className="text-center" data-id="element-231" data-mp="3b0uf3pkwpdzm">
          <span className="font-head text-[10px] font-semibold uppercase tracking-[0.14em] text-cta sm:text-xs" data-id="element-232" data-mp="3azt39iw2gngu">
            Built for Spanish teachers
          </span>
          <h2 id="testimonials-title" className="mt-0.5 font-head text-2xl font-bold uppercase leading-none text-white sm:text-4xl" data-id="element-233" data-mp="31zd2wiamdwg7">
            What professionals say
          </h2>
        </div>

        <div className="mt-3 grid gap-2 md:grid-cols-2 lg:grid-cols-3" data-id="element-234" data-mp="2s1yospc65jr2">
          {DETAILED_TESTIMONIALS.map(item => <figure key={item.name} className="flex flex-col rounded-xl border border-cta/20 bg-panel p-3" data-id="element-235" data-mp="v9ydr4zhpj73">
              <div className="flex items-center gap-2" data-id="element-236" data-mp="qa3mv1fpstm1">
                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-brand font-head text-[10px] font-bold text-white" data-id="element-237" data-mp="q8ixdq89c0v1">
                  {item.initials}
                </span>
                <Stars data-id="element-238" data-mp="m2onyzsoo4nz" />
              </div>
              <blockquote className="mt-1.5 text-[12px] leading-snug text-silver" data-id="element-239" data-mp="78tup250gnxw">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-auto pt-2 font-head text-[11px] font-semibold uppercase tracking-wide text-white" data-id="element-240" data-mp="c8y1g0g4a4ax">
                {item.name}
                <span className="mt-0.5 block font-body text-[10px] font-medium normal-case tracking-normal text-cta" data-id="element-241" data-mp="14vskqu176xmt">
                  {item.role}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}